import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';
import { FilterConfigService, type FilterDataResult, SearchFilterModel } from '@ui/shared/util-filter';
import type { ProjectListFilterKey } from '../../types/project-list-filters';

@Injectable({ providedIn: 'root' })
export class SearchFilterConfigService extends FilterConfigService<ProjectListFilterKey, undefined> {
    public override placeholder = 'Name des Veranstaltungsortes';

    constructor() {
        super(
            new SearchFilterModel('search', 'Suchbegriff', []),
            undefined,
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return of({ data: [] });
    }
}
